import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import ScrollToTop from "./components/layout/ScrollToTop";
import HomePage from "./components/pages/HomePage";
import TechnologyPage from "./components/pages/TechnologyPage";
import ServicesPage from "./components/pages/ServicesPage";
import TrackRecordPage from "./components/pages/TrackRecordPage";
import ContactPage from "./components/pages/ContactPage";
import OnePage from "./components/pages/one_page";
import { Toaster } from "./components/ui/sonner";

function AppContent() {
  const location = useLocation();
  return (
    <>
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<OnePage />} />
          <Route path="/technology" element={<TechnologyPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/track-record" element={<TrackRecordPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/Home" element={<HomePage />} />
        </Routes>
      </main>
      {/* <Footer /> */}
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;